import { render, staticRenderFns } from "./DSR.vue?vue&type=template&id=7dcb4feb&"
import script from "./DSR.vue?vue&type=script&lang=js&"
export * from "./DSR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports